<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Añadir Horario</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-form class="text-center mt-6">
                        <v-card outlined>
                            <v-card-text>
                                <v-text-field
                                    v-model="name"
                                    label="Agregue un nombre"
                                    hide-details
                                    class="pa-1"
                                ></v-text-field>
                            </v-card-text>
                        </v-card>

                        <v-card outlined class="mt-6">
                            <v-card-text>
                                <v-dialog
                                    ref="dialog"
                                    v-model="time_modal"
                                    :return-value.sync="time"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="time"
                                            solo
                                            flat
                                            label="Seleccione una hora"
                                            prepend-inner-icon="mdi-clock-outline"
                                            readonly
                                            hide-details
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="time_modal"
                                        v-model="time"
                                        ampm-in-title
                                        full-width
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="time_modal = false"
                                            >Cancel</v-btn
                                        >
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.dialog.save(time)"
                                            >OK</v-btn
                                        >
                                    </v-time-picker>
                                </v-dialog>
                            </v-card-text>
                        </v-card>         
                        <v-card outlined class="mt-6">
                            <v-card-text>
                                <v-select
                                    label="Seleccione el valor"
                                    solo
                                    flat
                                    hide-details
                                    item-text="text"
                                    item-value="value"
                                    v-model="value"
                                    :items="[{
                                        text: 'Encender',
                                        value: true
                                    },{
                                        text: 'Apagar',
                                        value: false
                                    }]"
                                />
                            </v-card-text>
                        </v-card>   
                    </v-form>
                    
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue-grey lighten-1" dark small @click="close"
                        >Cancelar</v-btn
                    >
                    <v-btn color="accent" small @click="edit" v-if="schedule_id">Guardar cambios</v-btn>
                    <v-btn color="accent" small @click="save" v-else>Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'formSchedule',
    props: ['open', 'schedule_id'],
    computed:{
        ...mapGetters({ getSchedule: 'schedules/getSchedule' })
    },
    data() {
        return {
            name: '',
            time: null,
            time_modal: false,
            value: null,
            error: {
                message: '',
                active: false
            }
        }
    },
    methods: {
        ...mapActions({ 
            addSchedule: 'schedules/addSchedule',
            editSchedule: 'schedules/updateScheduleData' 
        }),
        reset(){
            this.name = ''
            this.time = null
            this.time_modal = false
            this.value = null
        },
        close() {
            this.reset()
            this.$emit('close')
        },
        async edit(){
            if(this.name == '' || this.time == null || this.value == null) return

            try {
                let time_int = this.time.split(':').map( t => parseInt(t))
                let hour = new Date()
                hour.setHours(time_int[0], time_int[1],0,0)

                await this.editSchedule({
                    schedule: this.schedule_id,
                    props: {
                        name: this.name,
                        time: `${hour.getUTCHours()}:${hour.getUTCMinutes()}`,
                        value: this.value
                    }
                })

                this.close()
            } catch (error) {
                console.log(error)
                this.error.message = error.message
                this.error.active = true
            }
        },
        async save(){
            if(this.name == '' || this.time == null || this.value == null) return

            try {
                let time_int = this.time.split(':').map( t => parseInt(t))
                let hour = new Date()
                hour.setHours(time_int[0], time_int[1],0,0)

                await this.addSchedule({
                    name: this.name,
                    time: `${hour.getUTCHours()}:${hour.getUTCMinutes()}`,
                    value: this.value,
                    gateways: [],
                    active: true
                })

                this.close()
            } catch (error) {
                this.error.message = error.message
                this.error.active = true
            }
        }
    },
    watch:{
        schedule_id(){
            if(!this.schedule_id) return
            const schedule = this.getSchedule(this.schedule_id)
            this.name = schedule.name
            this.value = schedule.value

            let time_int = schedule.time.split(':')
            let hour = new Date()
            hour.setUTCHours(parseInt(time_int[0]),parseInt(time_int[1]),0,0)
            this.time = `${hour.toLocaleTimeString()}`
        }
    }
}
</script>
